/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toolbar_Secondary_Open_Project_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Open Project" |
*
* @param {Toolbar_Secondary_Open_Project_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const toolbar_secondary_open_project_aria_label = /** @type {((inputs?: Toolbar_Secondary_Open_Project_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toolbar_Secondary_Open_Project_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrir un Projet")
	if (locale === "de") return /** @type {LocalizedString} */ ("Offenes Projekt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Apri progetto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Открытый проект")
	if (locale === "es") return /** @type {LocalizedString} */ ("Proyecto abierto")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("开放项目")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロジェクトを開く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ओपन प्रोजेक्ट")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Projeto Aberto")
	return /** @type {LocalizedString} */ ("Open Project")
});